export const THEME_KEY = 'theme';
